import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class CurrencyCalculator implements AnalyticsObject {
  name: string
  properties: CurrencyCalculatorProperties
  constructor(properties: CurrencyCalculatorProperties) {
    this.name = `Currency Calculator`
    this.properties = properties
  }
}
export interface CurrencyCalculatorProperties extends AnalyticsProperties {
  buttonType: 'edit' | 'calculator'
}
